import React from "react";
import ModalBasicLayout from "./ModalBasicLayout";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../lib/i18next";
import {
  BUTTON_RELOAD_PAGE,
  NEW_VERSION_DESCRIPTION,
  NEW_VERSION_TITLE,
} from "../../../locales/keysTranslations";
import ContainerModalActions from "../Containers/ContainerModalActions";
import {
  GRADIENT_PURPLE_FUCHSIA,
  GRADIENT_PURPLE_FUCHSIA_COLOR_TEXT,
} from "../../../utils/colors";

const ModalBlockVersionApp = ({ modalOpen }) => {
  const { t } = useTranslationApp();
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={() => {}}
      fullWidth={true}
      maxWidth="sm"
      scroll="paper"
      hasTitle={false}
      sx={{
        zIndex: 9999,
      }}
      sxPaper={{
        background: GRADIENT_PURPLE_FUCHSIA,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          color: GRADIENT_PURPLE_FUCHSIA_COLOR_TEXT,
        }}
      >
        <Typography variant="h5" align="left" sx={{ fontWeight: 600 }}>
          {t(NEW_VERSION_TITLE)}
        </Typography>
        <Typography variant="body1" align="left" sx={{ mb: 2 }}>
          {t(NEW_VERSION_DESCRIPTION)}
        </Typography>
        <ContainerModalActions
          hasPadding={false}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_RELOAD_PAGE,
            color: "primary",
            onClick: () => window.location.reload(),
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalBlockVersionApp;
